import { styled } from '../../../common/ui'

export const Line = styled.div`
  border-top: 1px solid #91c581;
  padding-bottom: 25px;
`
